module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('page-title', [(_vm.item) ? _c('h2', [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'CustomerList'
      }
    }
  }, [_vm._v("Klienci")]), _vm._v("/Edycja")], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col page-element"
  }, [(_vm.updated) ? _c('div', {
    staticClass: "alert alert-success",
    attrs: {
      "role": "status"
    }
  }, [_vm._v("Klient " + _vm._s(_vm.updated.fullName) + " został zapisany.")]) : _vm._e(), _vm._v(" "), (_vm.retrieveLoading || _vm.updateLoading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), (_vm.retrieveError) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-exclamation-sign",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.retrieveError))]) : _vm._e(), _vm._v(" "), (_vm.updateError) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-exclamation-sign",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.updateError))]) : _vm._e(), _vm._v(" "), (_vm.deleteError) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-exclamation-sign",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.deleteError))]) : _vm._e(), _vm._v(" "), (_vm.item && !_vm.retrieveLoading && !_vm.updateLoading) ? _c('CustomerForm', {
    attrs: {
      "handle-submit": _vm.update,
      "values": _vm.item,
      "errors": _vm.violations,
      "initialValues": _vm.retrieved
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-83020df0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/customer/Update.vue
// module id = 830
// module chunks = 0